<div class="years-info-container" *ngIf="isChartVisible">
  <button
    type="button"
    class="year-step-button"
    [disabled]="!canStepBack"
    (click)="stepYear(-1)"
    aria-label="Show an earlier year"
  >
    <app-icon
      class="arrow-right-icon year-step-icon--prev"
      svgIcon="arrow_right"
    ></app-icon>
  </button>

  <span class="selected-year">{{ selectedYear }}</span>

  <button
    type="button"
    class="year-step-button"
    [disabled]="!canStepForward"
    (click)="stepYear(1)"
    aria-label="Show a later year"
  >
    <app-icon class="arrow-right-icon" svgIcon="arrow_right"></app-icon>
  </button>
</div>
